export default {
  tab: {
    'rendering-engine': 'Rendering engine',
    'barcode-scanner': 'Barcode scanner',
    'api-explorer': 'API explorer',
  },
};
